import Vue from 'vue'
import {
  Button, Input, Row, Card, Form, FormItem, Message, Footer, Aside, Container, Main, Header, Menu, MenuItem, Submenu,
  Dropdown, DropdownMenu, DropdownItem, Avatar, Dialog, Breadcrumb, BreadcrumbItem, Col, Table, TableColumn, Loading, Pagination, Drawer, MessageBox, Tooltip
} from 'element-ui'

// 注册组件
Vue.use(Button)
Vue.use(Input)
Vue.use(Row)
Vue.use(Card)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Footer)
Vue.use(Aside)
Vue.use(Container)
Vue.use(Main)
Vue.use(Header)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Avatar)
Vue.use(Dialog)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Col)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Drawer)
Vue.use(Tooltip)

// 注册指令 - 关键修复
Vue.use(Loading.directive)

// 注册原型方法
Vue.prototype.$message = Message
Vue.prototype.$loading = Loading.service
Vue.prototype.$confirm = MessageBox.confirm
